export enum EventSounds {
  CHIPS_PULLING = 'CHIPS_PULLING',
  CHIPS_PUSHING = 'CHIPS_PUSHING',
  HOLE_DEAL = 'HOLE_DEAL',
  BOARD_DEAL = 'BOARD_DEAL',
  FLOP = 'FLOP',
  TURN = 'TURN',
  RIVER = 'RIVER',
  RAISE = 'RAISE',
  BET = 'BET',
  FOLD = 'FOLD',
  CALL = 'CALL',
  CHECK = 'CHECK',
  COMPLETE = 'COMPLETE',
  POST_BRING_IN = 'POST_BRING_IN',
  DISCARD = 'DISCARD',
  STAND_PAT = 'STAND_PAT',
  ALL_IN = 'ALL_IN',
  FIRST_WARNING = 'FIRST_WARNING',
  SECOND_WARNING = 'SECOND_WARNING',
  TABLE_SEAT_READY = 'TABLE_SEAT_READY',
}

export enum SoundGroup {
  ACTIONS = 'ACTIONS',
  ALERTS = 'ALERTS',
  CHIPS = 'CHIPS',
  DEAL = 'DEAL',
}

export interface SoundConfig {
  asset: string;
  volume: number;
  group: SoundGroup;
}
